import { render, staticRenderFns } from "./SupplyHistoryIcon.vue?vue&type=template&id=0f429240"
import script from "./SupplyHistoryIcon.vue?vue&type=script&lang=ts"
export * from "./SupplyHistoryIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports